import { Hidden } from "@mui/material";
import { FC, PropsWithChildren } from "react";
import { AdDataType } from "../../utils/data";
import { conciseAddress } from "../../utils/formatter";
import { CustomizedButton } from "../Buttons/CustomizedButton";

interface AdDataProps {
  adData: AdDataType;
}

const AdCard: FC<AdDataProps> = ({ adData }) => {
  return (
    <section className=" dark:bg-gray-900">
      <div>
        <img
          className="object-cover object-center w-full h-44 rounded-lg lg:h-60"
          src={adData.projectLogo}
          alt="logo"
        />
        <div className="mt-8 px-2 pb-5">
          <span className=" uppercase text-green-900">{adData.status}</span>
          <h1 className="mt-4 text-xl font-semibold text-gray-800 dark:text-white">
            {adData.companyName}
          </h1>
          <p
            className="mt-2 text-gray-500 dark:text-gray-400 "
            style={{
              overflow: "hidden",
              textOverflow: "ellipsisHidden",
              display: "-webkit-box",
              WebkitLineClamp: "2",
              lineClamp: "2",
              WebkitBoxOrient: "vertical",
            }}
          >
            {adData.description}
          </p>
          <div className="flex items-center justify-between mt-4">
            <div>
              <span className="text-lg font-medium text-gray-700 dark:text-gray-300 hover:underline hover:text-gray-500">
                {conciseAddress(adData.address)}
              </span>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                {adData.startDate}
              </p>
            </div>
          </div>
          <div className="flex text-center place-content-center pt-5 ">
            <CustomizedButton text="View Details" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdCard;
